import {
  Component,
  OnInit,
  Input,
  SimpleChanges,
  OnChanges,
  AfterViewInit,
  ViewChild,
} from '@angular/core';

import { FormGroup } from '@angular/forms';
import { UiFactory } from '../../core/ui/ui-factory';
import { PgInputDirective } from '../pg-input/pg-input.directive';
import { StateSelectInputModel } from '../pg-input-factory/input-model';
import { BehaviorService } from '../../core/behavior/behavior.service';
import { FactoryFormControlBuilder } from '../pg-input-factory/factory-form-control-builder';

@Component({
  selector: 'pg-state-select-input',
  templateUrl: './pg-state-select-input.component.html',
  styleUrls: ['./pg-state-select-input.component.scss'],
})
export class PgStateSelectInputComponent extends UiFactory
  implements OnChanges, AfterViewInit {
  @Input() model: any;

  @Input() parentFormGroup: FormGroup;

  @ViewChild(PgInputDirective, { static: true })
  input: PgInputDirective;

  searchTerms = [];

  get stateSelectInputModel(): StateSelectInputModel {
    return this.model;
  }

  constructor(
    public behaviorService: BehaviorService,
    public factoryFormBuilder: FactoryFormControlBuilder
  ) {
    super(behaviorService);
  }

  ngOnInit() {
    super.ngOnInit();

    this.factoryFormBuilder.buildFormWithModel(
      this.parentFormGroup,
      this.stateSelectInputModel.formControlName,
      this.stateSelectInputModel.validationList,
      false
    );
    this._buildSearchTerms();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.model && !changes.model.firstChange) {
      // Check for changes in validation list because we will have to re-build form validators
      const prev: StateSelectInputModel = changes.model.previousValue || {};
      const next: StateSelectInputModel = changes.model.currentValue || {};
      const prevValidationList = prev.validationList || [];
      const nextValidationList = prev.validationList || [];
      const difference = prevValidationList.filter(
        x => !nextValidationList.find(i => i.errorKey === x.errorKey)
      );
      if (difference || difference.length) {
        this.factoryFormBuilder.buildFormWithModel(
          this.parentFormGroup,
          this.stateSelectInputModel.formControlName,
          this.stateSelectInputModel.validationList,
          false
        );
      }
      this._buildSearchTerms();
    }
  }
  ngAfterViewInit() {}

  handleBehaviorEvent(eventName, event: Event) {
    event.stopPropagation();
    event.stopImmediatePropagation();
    event.preventDefault();
    if (
      this.stateSelectInputModel[eventName] &&
      this.stateSelectInputModel[eventName].length
    ) {
      this.behaviorService.execute(this.stateSelectInputModel[eventName], {
        target: this,
        targetModel: this.stateSelectInputModel,
        value: this.input.value,
        formGroup: this.parentFormGroup,
      });
    }
    // TODO: dont forget to set up handlers for behavior events.
  }

  public _buildSearchTerms() {
    let tmp = [...stateSearch];

    // Add any additional search terms
    if (this.stateSelectInputModel.additionalStates) {
      tmp = tmp.concat(this.stateSelectInputModel.additionalStates);
    }

    // Filter out specific states
    if (this.stateSelectInputModel.excludedStates) {
      this.stateSelectInputModel.excludedStates.forEach(exclude => {
        tmp = tmp.filter(s => s.value !== exclude);
      });
    }

    this.searchTerms = tmp;
  }
}

const stateSearch = [
  {
    value: 'AL',
    searchTerms: ['AL', 'Alabama'],
    display: 'Alabama',
  },
  {
    value: 'AK',
    searchTerms: ['AK', 'Alaska'],
    display: 'Alaska',
  },
  {
    value: 'AZ',
    searchTerms: ['AZ', 'Arizona'],
    display: 'Arizona',
  },
  {
    value: 'AR',
    searchTerms: ['AR', 'Arkansas'],
    display: 'Arkansas',
  },
  {
    value: 'CA',
    searchTerms: ['CA', 'California'],
    display: 'California',
  },
  {
    value: 'CO',
    searchTerms: ['CO', 'Colorado'],
    display: 'Colorado',
  },
  {
    value: 'CT',
    searchTerms: ['CT', 'Connecticut'],
    display: 'Connecticut',
  },
  {
    value: 'DE',
    searchTerms: ['DE', 'Delaware'],
    display: 'Delaware',
  },
  {
    value: 'FL',
    searchTerms: ['FL', 'Florida'],
    display: 'Florida',
  },
  {
    value: 'GA',
    searchTerms: ['GA', 'Georgia'],
    display: 'Georgia',
  },
  {
    value: 'HI',
    searchTerms: ['HI', 'Hawaii'],
    display: 'Hawaii',
  },
  {
    value: 'ID',
    searchTerms: ['ID', 'Idaho'],
    display: 'Idaho',
  },
  {
    value: 'IL',
    searchTerms: ['IL', 'Illinois'],
    display: 'Illinois',
  },
  {
    value: 'IN',
    searchTerms: ['IN', 'Indiana'],
    display: 'Indiana',
  },
  {
    value: 'IA',
    searchTerms: ['IA', 'Iowa'],
    display: 'Iowa',
  },
  {
    value: 'KS',
    searchTerms: ['KS', 'Kansas'],
    display: 'Kansas',
  },
  {
    value: 'KY',
    searchTerms: ['KY', 'Kentucky'],
    display: 'Kentucky',
  },
  {
    value: 'LA',
    searchTerms: ['LA', 'Louisiana'],
    display: 'Louisiana',
  },
  {
    value: 'ME',
    searchTerms: ['ME', 'Maine'],
    display: 'Maine',
  },
  {
    value: 'MD',
    searchTerms: ['MD', 'Maryland'],
    display: 'Maryland',
  },
  {
    value: 'MA',
    searchTerms: ['MA', 'Massachusetts'],
    display: 'Massachusetts',
  },
  {
    value: 'MI',
    searchTerms: ['MI', 'Michigan'],
    display: 'Michigan',
  },
  {
    value: 'MN',
    searchTerms: ['MN', 'Minnesota'],
    display: 'Minnesota',
  },
  {
    value: 'MS',
    searchTerms: ['MS', 'Mississippi'],
    display: 'Mississippi',
  },
  {
    value: 'MO',
    searchTerms: ['MO', 'Missouri'],
    display: 'Missouri',
  },
  {
    value: 'MT',
    searchTerms: ['MT', 'Montana'],
    display: 'Montana',
  },
  {
    value: 'NE',
    searchTerms: ['NE', 'Nebraska'],
    display: 'Nebraska',
  },
  {
    value: 'NV',
    searchTerms: ['NV', 'Nevada'],
    display: 'Nevada',
  },
  {
    value: 'NH',
    searchTerms: ['NH', 'New Hampshire'],
    display: 'New Hampshire',
  },
  {
    value: 'NJ',
    searchTerms: ['NJ', 'New Jersey'],
    display: 'New Jersey',
  },
  {
    value: 'NM',
    searchTerms: ['NM', 'New Mexico'],
    display: 'New Mexico',
  },
  {
    value: 'NY',
    searchTerms: ['NY', 'New York'],
    display: 'New York',
  },
  {
    value: 'NC',
    searchTerms: ['NC', 'North Carolina'],
    display: 'North Carolina',
  },
  {
    value: 'ND',
    searchTerms: ['ND', 'North Dakota'],
    display: 'North Dakota',
  },
  {
    value: 'OH',
    searchTerms: ['OH', 'Ohio'],
    display: 'Ohio',
  },
  {
    value: 'OK',
    searchTerms: ['OK', 'Oklahoma'],
    display: 'Oklahoma',
  },
  {
    value: 'OR',
    searchTerms: ['OR', 'Oregon'],
    display: 'Oregon',
  },
  {
    value: 'PA',
    searchTerms: ['PA', 'Pennsylvania'],
    display: 'Pennsylvania',
  },
  {
    value: 'RI',
    searchTerms: ['RI', 'Rhode Island'],
    display: 'Rhode Island',
  },
  {
    value: 'SC',
    searchTerms: ['SC', 'South Carolina'],
    display: 'South Carolina',
  },
  {
    value: 'SD',
    searchTerms: ['SD', 'South Dakota'],
    display: 'South Dakota',
  },
  {
    value: 'TN',
    searchTerms: ['TN', 'Tennessee'],
    display: 'Tennessee',
  },
  {
    value: 'TX',
    searchTerms: ['TX', 'Texas'],
    display: 'Texas',
  },
  {
    value: 'UT',
    searchTerms: ['UT', 'Utah'],
    display: 'Utah',
  },
  {
    value: 'VT',
    searchTerms: ['VT', 'Vermont'],
    display: 'Vermont',
  },
  {
    value: 'VA',
    searchTerms: ['VA', 'Virginia'],
    display: 'Virginia',
  },
  {
    value: 'WA',
    searchTerms: ['WA', 'Washington'],
    display: 'Washington',
  },
  {
    value: 'WV',
    searchTerms: ['WV', 'West Virginia'],
    display: 'West Virginia',
  },
  {
    value: 'WI',
    searchTerms: ['WI', 'Wisconsin'],
    display: 'Wisconsin',
  },
  {
    value: 'WY',
    searchTerms: ['WY', 'Wyoming'],
    display: 'Wyoming',
  },
];
